import { CEProcessStepAssociationAttributesBase } from './ce-process-step-association-attributes-base'


export class CEProcessStepAssociationAttributes extends CEProcessStepAssociationAttributesBase {

}